import * as React from "react";
import { Button, Box } from "@mui/material";
// import type { SxProps, Theme } from "@mui/material/styles";


function renderIcon(icon) {
    if (!icon) return undefined;

    // If a URL string: render an <img>
    if (typeof icon === "string") {
        return (
            <Box
                component="img"
                src={icon}
                alt=""
                sx={{ width: 20, height: 20, display: "block" }}
            />
        );
    }

    // If a React element already: use as-is
    if (React.isValidElement(icon)) return icon;

    // If a component (e.g., a MUI Icon): instantiate it
    const IconComp = icon;
    return <IconComp sx={{ fontSize: 20 }} />;
}

export default function DynamicPillButton({
    label,
    onClick,
    icon,
    iconPosition = "end",
    bg = "#25D366",
    color = "#fff",
    href,
    fullWidth = false,
    size = "md",
    sx,
}) {
    const iconNode = renderIcon(icon);

    const sizeStyles =
        size === "sm"
            ? { height: 36, px: 2 }
            : size === "lg"
                ? { height: 52, px: 3 }
                : { height: 44, px: 2.5 }; // md

    const iconProps =
        iconNode && iconPosition === "start"
            ? { startIcon: iconNode }
            : iconNode
                ? { endIcon: iconNode }
                : {};

    return (
        <Button
            {...iconProps}
            onClick={onClick}
            fullWidth={fullWidth}
            variant="contained"
            component={href ? "a" : "button"}
            href={href}
            sx={{
                borderRadius: 999,
                textTransform: "none",
                fontWeight: 700,
                fontSize: 16,
                color,
                // support both solid and gradient
                bgcolor: bg,
                background: bg,
                boxShadow: "none",
                "&:hover": {
                    filter: "brightness(.97)",
                    boxShadow: "0 8px 20px rgba(0,0,0,.18)",
                },
                ...sizeStyles,
                ...sx,
            }}
        >
            {label}
        </Button>
    );
}
